import React, { useEffect, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

const CheckoutForm = ({order}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [cardError, setCardError] = useState('');
  const [success, setSuccess] = useState('');
  const [processing, setProcessing] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const {_id, price, email, userName}=order;
  
  useEffect(()=>{
    fetch('https://warm-caverns-09302.herokuapp.com/create-payment-intent',{
        method: 'POST',
        headers:{
            authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            "Content-Type": "application/json",
        },
        body:JSON.stringify({price})
    })
    .then(res=>res.json())
    .then(data=>{
        if (data?.clientSecret) {
            setClientSecret(data.clientSecret);
        }
    })
},[price])

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    const card = elements.getElement(CardElement);

    if (card == null) {
      return;
    }
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card,
    });
    setCardError(error?.message || '');
    setSuccess('');
    setProcessing(true);
    //confirm card payment
    const {paymentIntent, error: intentError} = await stripe.confirmCardPayment(
        clientSecret,
        {
          payment_method: {
            card: card,
            billing_details: {
              name: userName,
              email: email,
            },
          },
        },
      );
      if (intentError) {
        setCardError(intentError?.message);
        setSuccess('');
        setProcessing(false);
      }else{
        setCardError('');
        setTransactionId(paymentIntent.id);
        console.log(paymentIntent);
        setSuccess('Congrats! Your payment is completed.');
        //store payment on db
        const payment = {
            order: _id,
            transactionId: paymentIntent.id
        }
        fetch(`https://warm-caverns-09302.herokuapp.com/order/${_id}`,{
            method: "PATCH",
            headers: {
              authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payment)
        }).then(res=>res.json()).then(data=>{
            console.log(data);
            setProcessing(false);
        })
      }
  };
  return (
    <>
    <form onSubmit={handleSubmit}>
      <CardElement
        options={{
          style: {
            base: {
              fontSize: "16px",
              color: "#424770",
              "::placeholder": {
                color: "#aab7c4",
              },
            },
            invalid: {
              color: "#9e2146",
            },
          },
        }}
      />
      <button className="btn btn-success btn-sm px-6 mt-4" type="submit" disabled={!stripe || !clientSecret || success}>
        Pay
      </button>
    </form>
    {cardError && <p className="text-red-500">{cardError}</p>}
    {success && <div className="text-success">
        <p>{success}</p>
        <p>Your transaction Id: <span className="text-orange-500 font-bold">{transactionId}</span></p>
        </div>}
    </>
  );
};

export default CheckoutForm;
